import { Influencer } from '@foodfluence/shared';

type DiamondCelebrationInfluencer =
  | Pick<Influencer, 'id' | 'isDiamond' | 'showDiamondTierIntro'>
  | null
  | undefined;

/**
 * True when a Diamond creator has not yet dismissed the Diamond Tier celebration.
 *
 * `isDiamond` is the gate that keeps never-marked creators from ever seeing the modal, so
 * the flag itself follows the same default-to-shown convention as its `show*` siblings
 * (see walletPayoutIntroUtils). Marking a creator resets the flag server-side, which is
 * what makes a re-marked creator see the celebration again.
 */
export const shouldShowDiamondCelebration = (
  influencer: DiamondCelebrationInfluencer
): boolean => {
  if (!influencer?.id) return false;
  if (influencer.isDiamond !== true) return false;
  return influencer.showDiamondTierIntro !== false;
};
